import { PERMISSIONS, ROLES } from '@savgroup-front-common/constants';

import { LoginState } from '../types';

interface AdaptUserToLoginStateArgs {
  currentState: LoginState;
  payload: Partial<LoginState>;
}

export const adaptUserToLoginState = ({
  currentState,
  payload,
}: AdaptUserToLoginStateArgs): LoginState => {
  const { permissions, roles, profiles } = (
    payload.rolePermissions || []
  ).reduce<{
    permissions: PERMISSIONS[];
    roles: ROLES[];
    profiles: string[];
  }>(
    (acc, rolePermission) => {
      const nextPermissions = (rolePermission?.permissions || []).reduce<
        PERMISSIONS[]
      >((permissionsAcc, permission) => {
        if (permissionsAcc.includes(permission)) {
          return permissionsAcc;
        }

        return [...permissionsAcc, permission];
      }, acc.permissions);

      const nextRoles =
        rolePermission.builtInRole !== ROLES.CUSTOM_PROFILE
          ? [...acc.roles, rolePermission.builtInRole]
          : acc.roles;
      const nextProfiles =
        rolePermission.builtInRole === ROLES.CUSTOM_PROFILE
          ? [...acc.profiles, rolePermission.roleName]
          : acc.profiles;

      return {
        permissions: nextPermissions,
        roles: nextRoles,
        profiles: nextProfiles,
      };
    },
    { permissions: [], roles: [], profiles: [] },
  );

  return {
    ...currentState,
    ...payload,
    isLoggedIn: !payload.failure,
    permissions,
    roles,
    profiles,
  };
};
